import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch, MdOutlineLogout } from "react-icons/md";
import Button from "react-bootstrap/Button";
import {
  VoucherExportApi,
  VoucherTransactionsApi,
} from "../../Utils/Api/VoucherTransactionsApi";
import { RemoveSortkeys, userId } from "../../Utils/LocalStorage";
import { format } from "date-fns";
import { Image } from "react-bootstrap";
import view from "../../assets/view.svg";
import Pagination from "../../Components/Pagination/Pagination";
import Loader from "../../Components/Loader/Loader";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { saveAs } from "file-saver";
import SearchBarResults from "../../Components/Search/SearchBarResults";
import { toast } from "react-toastify";
import { FormatDateShortMonth } from "./../../Utils/FormatDateShortMonth";

const CouponAndVoucherTransactions = ({ toggle }) => {
  const [voutransaction, setVoutransaction] = useState([]);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [flag, setFlag] = useState({
    dateSort: 0,
    orderNumber: 0,
    email: 0,
    voucherName: 0,
    marketplace: 0,
    amount: 0,
  });
  const [exportFlag, setExportFlag] = useState(false);
  const [mouseEnterAndLeave, setMouseEnterAndLeave] = useState(false);
  const [indexOfItems, setIndexOfItems] = useState("");

  const Bu_id = userId();

  const navigate = useNavigate();

  const handleApi = async (searchVal, sortval, colName) => {
    if (colName) {
      localStorage.setItem("colName", colName);
    }
    if (sortval) {
      localStorage.setItem("sortval", sortval);
    }

    const ColName = localStorage.getItem("colName");
    const SortVal = parseInt(localStorage.getItem("sortval"));
    const data = {
      //hardcoded data
      bu_id: parseInt(Bu_id),
      toggle: toggle,
      limit: 10,
      offset: searchVal ? 0 : pageNumber,
      search_value: searchVal,
      column_name: ColName ? ColName : colName,
      sort_type: SortVal ? SortVal : sortval,
    };

    // console.log(data);
    if (!data.sort_type && !data.column_name) {
      setLoading(true);
    }

    const transactionList = await VoucherTransactionsApi(data, () => {
      navigate("/");
    });

    if (!data.sort_type && !data.column_name) {
      setLoading(false);
    }
    if (transactionList.status === 429) {
      setLoading(true);
      toast.error(transactionList.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
    setVoutransaction(transactionList.data);
    setTotalPageCount(transactionList.total_page_count);
    setLimit(transactionList.limit);
  };

  const ExportHandlerAPI = async () => {
    const data1 = {
      bu_id: parseInt(Bu_id),
      toggle: toggle,
      limit: 10,
      offset: search ? 0 : pageNumber,
      search_value: search,
      // column_name: colName,
      // sort_type: sortval,
      export: exportFlag,
    };
    setLoading(true);
    const exportBlB = await VoucherExportApi(data1);
    setLoading(false);
    let blob = new Blob([exportBlB], { type: "application/vnd.ms-excel" });
    const TodayDate = format(Date.now(), "yyyy/MM/dd");
    saveAs(
      blob,
      toggle === 0
        ? `voucher_transaction_history_${TodayDate}.xlsx`
        : `Coupon_transaction_history_${TodayDate}.xlsx`
    );
  };

  const HandleSortDate = () => {
    if (flag.dateSort === 0) {
      handleApi(
        search,
        1,
        toggle === 0 ? "euvi_purchased_at" : "euci_downloaded_at"
      );
      setFlag((ps) => {
        return { ...ps, dateSort: 1 };
      });
    } else if (flag.dateSort === 1) {
      handleApi(
        search,
        2,
        toggle === 0 ? "euvi_purchased_at" : "euci_downloaded_at"
      );
      setFlag((ps) => {
        return { ...ps, dateSort: 2 };
      });
    } else {
      handleApi(
        search,
        0,
        toggle === 0 ? "euvi_purchased_at" : "euci_downloaded_at"
      );
      setFlag((ps) => {
        return { ...ps, dateSort: 0 };
      });
    }
  };

  // const HandleSortOrder = () => {
  //   if (flag.orderNumber === 0) {
  //     handleApi(search, 1, toggle === 0 ? "euvi_id" : "euci_id");
  //     setFlag((ps) => {
  //       return { ...ps, orderNumber: 1 };
  //     });
  //   } else if (flag.orderNumber === 1) {
  //     handleApi(search, 2, toggle === 0 ? "euvi_id" : "euci_id");
  //     setFlag((ps) => {
  //       return { ...ps, orderNumber: 2 };
  //     });
  //   } else {
  //     handleApi(
  //       search,
  //       0,
  //       toggle === 0 ? "euvi_purchased_at" : "euci_downloaded_at"
  //     );
  //     setFlag((ps) => {
  //       return { ...ps, orderNumber: 0 };
  //     });
  //   }
  // };

  const HandleSortEmail = () => {
    if (flag.email === 0) {
      handleApi(search, 1, "eu_email");
      setFlag((ps) => {
        return { ...ps, email: 1 };
      });
    } else if (flag.email === 1) {
      handleApi(search, 2, "eu_email");
      setFlag((ps) => {
        return { ...ps, email: 2 };
      });
    } else {
      handleApi(
        search,
        0,
        toggle === 0 ? "euvi_purchased_at" : "euci_downloaded_at"
      );
      setFlag((ps) => {
        return { ...ps, email: 0 };
      });
    }
  };

  const HandleSortVoucherName = () => {
    if (flag.voucherName === 0) {
      handleApi(search, 1, toggle === 0 ? "voucher_name" : "coupon_name");
      setFlag((ps) => {
        return { ...ps, voucherName: 1 };
      });
    } else if (flag.voucherName === 1) {
      handleApi(search, 2, toggle === 0 ? "voucher_name" : "coupon_name");
      setFlag((ps) => {
        return { ...ps, voucherName: 2 };
      });
    } else {
      handleApi(
        search,
        0,
        toggle === 0 ? "euvi_purchased_at" : "euci_downloaded_at"
      );
      setFlag((ps) => {
        return { ...ps, voucherName: 0 };
      });
    }
  };

  const HandleSortMarketPlace = () => {
    if (flag.marketplace === 0) {
      handleApi(search, 1, "mms_city_name");
      setFlag((ps) => {
        return { ...ps, marketplace: 1 };
      });
    } else if (flag.marketplace === 1) {
      handleApi(search, 2, "mms_city_name");
      setFlag((ps) => {
        return { ...ps, marketplace: 2 };
      });
    } else {
      handleApi(
        search,
        0,
        toggle === 0 ? "euvi_purchased_at" : "euci_downloaded_at"
      );
      setFlag((ps) => {
        return { ...ps, marketplace: 0 };
      });
    }
  };

  const HandleSortAmount = () => {
    if (flag.amount === 0) {
      handleApi(search, 1, "payment_amount");
      setFlag((ps) => {
        return { ...ps, amount: 1 };
      });
    } else if (flag.amount === 1) {
      handleApi(search, 2, "payment_amount");
      setFlag((ps) => {
        return { ...ps, amount: 2 };
      });
    } else {
      handleApi(search, 0, "euvi_purchased_at");
      setFlag((ps) => {
        return { ...ps, amount: 0 };
      });
    }
  };

  const handleChange = (e) => {
    let val = e.target.value;
    setSearch(val.trim());
    if (!val) {
      handleApi("");
    }
  };

  const handleSearchClick = () => {
    handleApi(search);
  };

  const HandleMouseEnter = (i) => {
    setIndexOfItems(i);
    setMouseEnterAndLeave(true);
  };

  const HandleMouseLeave = () => {
    setMouseEnterAndLeave(false);
  };

  const HandleExport = () => {
    setExportFlag(true);
  };

  useEffect(() => {
    if (exportFlag === true) {
      ExportHandlerAPI();
      setExportFlag(false);
    }
  }, [exportFlag]);

  const win = window.location.href;

  useEffect(() => {
    RemoveSortkeys();
  }, [win]);

  useEffect(() => {
    handleApi();
    window.scrollTo(0, 0);
  }, [pageNumber]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="manage-vou-main pt-3 pb-3">
        {/* <div>
          <img loading="lazy" src=""></img>
        </div> */}
        <p className="page-maintitle pt-2">Customer Management</p>
        <div className="manage-vou">
          <InputGroup className="search-bar">
            <InputGroup.Text>
              <MdSearch />
              <Form.Control
                type="text"
                placeholder="Search"
                maxLength={20}
                onChange={handleChange}
              />
            </InputGroup.Text>
            <Button variant="outline-secondary" onClick={handleSearchClick}>
              Search
            </Button>
          </InputGroup>
          <Button
            onClick={HandleExport}
            variant="primary"
            className="create-btn export-btn-main"
          >
            Export <MdOutlineLogout className="export-btn" />
          </Button>
        </div>
      </div>
      <SearchBarResults SearchValue={search} />
      <div className="table-responsive-xl black-header">
        <table className="recentact-table mt-3 table ver-middle manage-vou-table">
          <thead>
            <tr>
              <th>
                <Button onClick={HandleSortDate} className="tableheaders">
                  Date{" "}
                  {flag.dateSort === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.dateSort === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  // onClick={HandleSortOrder}
                  className="tableheaders"
                  style={{ margin: "auto", cursor: "text" }}
                >
                  {" "}
                  {toggle === 0 ? "Voucher ID" : "Coupon ID"}{" "}
                  {/* {flag.orderNumber === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.orderNumber === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}{" "} */}
                </Button>
              </th>
              <th>
                <Button
                  onClick={HandleSortEmail}
                  className="tableheaders"
                  style={{ marginLeft: "0" }}
                >
                  Customer Email Address
                  {flag.email === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.email === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  onClick={HandleSortVoucherName}
                  className="tableheaders"
                  style={{ marginLeft: "0" }}
                >
                  {toggle === 0 ? "Voucher Name" : "Coupon Name"}{" "}
                  {flag.voucherName === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.voucherName === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  onClick={HandleSortMarketPlace}
                  className="tableheaders"
                  style={{ margin: "auto" }}
                >
                  Marketplace{" "}
                  {flag.marketplace === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.marketplace === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              {toggle === 0 ? (
                <th>
                  <Button
                    onClick={HandleSortAmount}
                    className="tableheaders"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    Amount{" "}
                    {flag.amount === 0 ? (
                      <FaSort></FaSort>
                    ) : flag.amount === 1 ? (
                      <FaSortUp></FaSortUp>
                    ) : (
                      <FaSortDown></FaSortDown>
                    )}
                  </Button>
                </th>
              ) : (
                <></>
              )}
              <th style={{ textAlign: "center" }}>Actions </th>
            </tr>
          </thead>

          <tbody>
            {voutransaction && voutransaction.length > 0 ? (
              voutransaction.map((item, index) => {
                return (
                  <tr>
                    <td style={{ textAlign: "left", padding: "20px" }}>
                      {FormatDateShortMonth(item.date)}
                    </td>
                    <td style={{ textAlign: "center" }}>{item.order_code}</td>
                    <td style={{ textAlign: "left" }}>{item.email}</td>
                    {/* <td
                      className="text-left text-limit-2"
                      title="$25 eGift Card to Krispy Kreme; Valid Any Day $25 eGift Card to Krispy Kreme; Valid Any Day"
                    >
                      $25 eGift Card to Krispy Kreme; Valid Any Day $25 eGift
                      Card to Krispy Kreme; Valid Any Day
                    </td> */}
                    <td
                      className="text-left text-limit-2"
                      style={{ textAlign: "left", padding: "0" }}
                    >
                      {item.order_name}
                    </td>
                    <td style={{ textAlign: "center" }}>{item.marketplace}</td>
                    {toggle === 0 ? (
                      <td className="green-text" style={{ textAlign: "right" }}>
                        <b>+ ${item.amount}</b>
                      </td>
                    ) : (
                      <></>
                    )}
                    {/* <td>{formatedDateRedeem}</td> */}
                    <td
                      onMouseEnter={() => HandleMouseEnter(index)}
                      onMouseLeave={() => HandleMouseLeave()}
                      style={{ textAlign: "center" }}
                    >
                      {indexOfItems === index && mouseEnterAndLeave === true ? (
                        <Link
                          title="Active"
                          to="/customer-details"
                          state={{
                            VoucherTransactionsData: item,
                            flag: toggle,
                          }}
                          className="Coupon_and_Voucher_view_btn"
                        >
                          View
                          {/* <Image loading="lazy" src={view}></Image> */}
                        </Link>
                      ) : (
                        <Link
                          title="Active"
                          to="/customer-details"
                          state={{
                            VoucherTransactionsData: item,
                            flag: toggle,
                          }}
                          className="Coupon_and_Voucher_view_btn"
                        >
                          <Image loading="lazy" src={view}></Image>
                        </Link>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={7} className="text-center">
                  <p className="no-record">No records available!</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div>
        {totalPageCount > 10 ? (
          <Pagination
            TotalPageCount={totalPageCount}
            Limit={limit}
            SetPageNumber={setPageNumber}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default CouponAndVoucherTransactions;
